import { useRef } from "react";
import Button from "../common/Button";

const Hero = ({ scrollToContact }) => {
  return (
    <section className="hero h-screen flex items-center justify-start text-white text-center lg:px-24 md:px-16 px-4">
      <div className="lg:text-left pt-16 w-full items-center lg:items-start lg:w-3/4 flex flex-col gap-2">
        <h1 className="text-5xl font-bold mb-4 ">
          Premier Facility for Manufacturing 100% Export-Quality Knitwear
        </h1>
        <p className="text-lg mb-6 font-merriweather">
          Where{" "}
          <span className="bg-gradient-to-r from-blue-500 via-red-300 to-blue-500 bg-[length:200%_auto] bg-clip-text text-transparent animate-gradient">
            Innovation, Efficiency, and Excellence
          </span>{" "}
          in Knitwear Meet Under One Roof
        </p>
        <button
          onClick={scrollToContact}
          className="w-fit px-6 hover:scale-105 duration-500 py-3 bg-white text-[#324999] rounded-lg shadow-lg font-semibold hover:bg-gray-200 transition"
        >
          Send Us a Message
        </button>
      </div>
    </section>
  );
};

export default Hero;
